import React from 'react'
import CategoryListing from './CategoryListing'

export default function CategoryManagment() {
  return (
    <CategoryListing/>
  )
}
